import _export from "../internals/export";
import _getBuiltIn from "../internals/get-built-in";
import _anObject from "../internals/an-object";
import _freezing from "../internals/freezing";
var $ = _export;
var getBuiltIn = _getBuiltIn;
var anObject = _anObject;
var FREEZING = _freezing;

// `Reflect.preventExtensions` method
// https://tc39.es/ecma262/#sec-reflect.preventextensions
$({
  target: "Reflect",
  stat: true,
  sham: !FREEZING
}, {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      var objectPreventExtensions = getBuiltIn("Object", "preventExtensions");
      if (objectPreventExtensions) objectPreventExtensions(target);
      return true;
    } catch (error) {
      return false;
    }
  }
});
export default {};